export default "__VITE_ASSET__3d751b0f__"